{
  "metadata": {
    "id": "matrix-dark",
    "name": "Matrix",
    "description": "Портировано из темы «Matrix» (dark)",
    "author": "OpenCode",
    "version": "2.0.0",
    "variant": "dark",
    "tags": [
      "dark",
      "ported"
    ],
    "source": {
      "file": "matrix.json",
      "project": "opencode",
      "url": "https://github.com/anomalyco/opencode",
      "upstreamFile": "packages/ui/src/theme/themes/matrix.json",
      "license": "MIT",
      "authoring": null
    },
    "validation": {
      "checks": 34,
      "fails": [],
      "paletteMinDeltaE": 25.6,
      "paletteTarget": 20.0,
      "paletteFloor": 18.0,
      "paletteAvgS": 0.477,
      "paletteMaxS": 0.529,
      "paletteAcid": 0,
      "surfacesMinDeltaE": 5.4,
      "surfacesTarget": 4.0,
      "surfacesRaisedTarget": 5.0,
      "surfacesAway": false,
      "syntaxMinDeltaE": 48.1,
      "syntaxVsTextMinDeltaE": 22.7,
      "chartsMinDeltaE": 22.2,
      "textSeparationDeltaE": 66.4,
      "textSeparationTarget": 10.0,
      "textSeparationFloor": 8.0,
      "textSeparationTinted": false,
      "authorialCollisions": [
        {
          "a": "function",
          "b": "operator",
          "deltaE": 0.0
        }
      ],
      "modeLabel": "dark",
      "modeFromLuminance": "dark",
      "paletteIdenticalToPeer": false
    }
  },
  "colors": {
    "primary": {
      "base": "#2eff6a",
      "hover": "#47ff7c",
      "active": "#58ff88",
      "foreground": "#000000",
      "muted": "#2eff6a80",
      "emphasis": "#2eff6a"
    },
    "surface": {
      "background": "#0a0e0a",
      "foreground": "#62ff94",
      "muted": "#162819",
      "mutedForeground": "#8ca391",
      "elevated": "#1a321f",
      "elevatedForeground": "#62ff94",
      "raised": "#275031",
      "raisedForeground": "#62ff94",
      "overlay": "#0a0e0acc",
      "subtle": "#121d13"
    },
    "interactive": {
      "border": "#275232",
      "borderHover": "#235131",
      "borderFocus": "#2eff6a",
      "selection": "#62ff9429",
      "selectionForeground": "#62ff94",
      "focus": "#2eff6a59",
      "focusRing": "#2eff6a61",
      "cursor": "#62ff94",
      "hover": "#62ff941c",
      "active": "#62ff9429"
    },
    "status": {
      "error": "#ff4b4b",
      "errorForeground": "#000000",
      "errorBackground": "#ff4b4b24",
      "errorBorder": "#ff4b4b73",
      "warning": "#e6ff57",
      "warningForeground": "#000000",
      "warningBackground": "#e6ff5724",
      "warningBorder": "#e6ff5773",
      "success": "#62ff94",
      "successForeground": "#000000",
      "successBackground": "#62ff9424",
      "successBorder": "#62ff9473",
      "info": "#30b3ff",
      "infoForeground": "#000000",
      "infoBackground": "#30b3ff24",
      "infoBorder": "#30b3ff73"
    },
    "pr": {
      "open": "#62ff94",
      "draft": "#8ca391",
      "blocked": "#e6ff57",
      "merged": "#c770ff",
      "closed": "#ff4b4b"
    },
    "syntax": {
      "base": {
        "background": "#182b1b",
        "foreground": "#62ff94",
        "comment": "#8ca391",
        "keyword": "#c770ff",
        "string": "#1cc24b",
        "number": "#ffa83d",
        "function": "#24f6d9",
        "variable": "#62ff94",
        "type": "#e6ff57",
        "operator": "#24f6d9"
      },
      "tokens": {
        "commentDoc": "#8ca391",
        "stringEscape": "#24f6d9",
        "keywordImport": "#c770ff",
        "storageModifier": "#c770ff",
        "functionCall": "#24f6d9",
        "method": "#24f6d9",
        "variableProperty": "#24f6d9",
        "variableOther": "#62ff94",
        "variableGlobal": "#ffa83d",
        "variableLocal": "#24f6d9",
        "parameter": "#62ff94",
        "constant": "#ffa83d",
        "class": "#e6ff57",
        "className": "#e6ff57",
        "interface": "#e6ff57",
        "struct": "#e6ff57",
        "enum": "#e6ff57",
        "typeParameter": "#e6ff57",
        "namespace": "#e6ff57",
        "module": "#c770ff",
        "tag": "#c770ff",
        "jsxTag": "#c770ff",
        "tagAttribute": "#24f6d9",
        "tagAttributeValue": "#1cc24b",
        "boolean": "#ffa83d",
        "decorator": "#c770ff",
        "label": "#24f6d9",
        "regexp": "#1cc24b"
      }
    },
    "charts": {
      "series": [
        "#2eff6a",
        "#30b3ff",
        "#62ff94",
        "#e6ff57",
        "#ff4b4b"
      ]
    },
    "chat": {
      "background": "#0a0e0a",
      "userMessage": "#62ff94",
      "userMessageBackground": "#1a321f",
      "assistantMessage": "#62ff94",
      "assistantMessageBackground": "#162819",
      "timestamp": "#8ca391",
      "divider": "#275232",
      "typing": "#8ca391"
    },
    "loading": {
      "spinner": "#2eff6a",
      "spinnerTrack": "#162819",
      "skeleton": "#162819",
      "shimmer": "#1c3822"
    },
    "tools": {
      "background": "#162819",
      "border": "#275232",
      "headerHover": "#1c3621",
      "icon": "#2eff6a",
      "title": "#62ff94",
      "description": "#8ca391",
      "edit": {
        "added": "#62ff94",
        "addedBackground": "#62ff9424",
        "removed": "#ff4b4b",
        "removedBackground": "#ff4b4b24",
        "modified": "#30b3ff",
        "modifiedBackground": "#30b3ff24",
        "lineNumber": "#8ca391"
      }
    },
    "markdown": {
      "heading1": "#62ff94",
      "heading2": "#62ff94",
      "heading3": "#62ff94",
      "heading4": "#62ff94",
      "link": "#2eff6a",
      "linkHover": "#47ff7c",
      "inlineCode": "#1cc24b",
      "inlineCodeBackground": "#162819",
      "blockquote": "#8ca391",
      "blockquoteBorder": "#275232",
      "listMarker": "#2eff6abf",
      "bold": "#62ff94",
      "italic": "#62ff94e6",
      "strikethrough": "#8ca391",
      "hr": "#275232"
    }
  },
  "palette": {
    "version": 1,
    "colors": [
      {
        "key": "a1",
        "name": "Красный",
        "hex": "#be4841",
        "foreground": "#ffffff",
        "contrast": 5.01
      },
      {
        "key": "a2",
        "name": "Лососевый",
        "hex": "#e0b2a3",
        "foreground": "#000000",
        "contrast": 11.07
      },
      {
        "key": "a3",
        "name": "Янтарный",
        "hex": "#c8a357",
        "foreground": "#000000",
        "contrast": 8.83
      },
      {
        "key": "a4",
        "name": "Салатовый",
        "hex": "#b0c755",
        "foreground": "#000000",
        "contrast": 11.15
      },
      {
        "key": "a5",
        "name": "Лаймовый",
        "hex": "#c8deac",
        "foreground": "#000000",
        "contrast": 14.5
      },
      {
        "key": "a6",
        "name": "Светло-зелёный",
        "hex": "#58c550",
        "foreground": "#000000",
        "contrast": 9.52
      },
      {
        "key": "a7",
        "name": "Зелёный",
        "hex": "#81d68f",
        "foreground": "#000000",
        "contrast": 11.95
      },
      {
        "key": "a8",
        "name": "Мятный",
        "hex": "#61bfa8",
        "foreground": "#000000",
        "contrast": 9.53
      },
      {
        "key": "a9",
        "name": "Бирюзовый",
        "hex": "#abd6dd",
        "foreground": "#000000",
        "contrast": 13.39
      },
      {
        "key": "a10",
        "name": "Голубой",
        "hex": "#5196b7",
        "foreground": "#000000",
        "contrast": 6.4
      },
      {
        "key": "a11",
        "name": "Синий",
        "hex": "#3949b9",
        "foreground": "#ffffff",
        "contrast": 7.43
      },
      {
        "key": "a12",
        "name": "Васильковый",
        "hex": "#9fa1dc",
        "foreground": "#000000",
        "contrast": 8.61
      },
      {
        "key": "a13",
        "name": "Фиолетовый",
        "hex": "#a578cf",
        "foreground": "#000000",
        "contrast": 6.19
      },
      {
        "key": "a14",
        "name": "Орхидея",
        "hex": "#c049b9",
        "foreground": "#000000",
        "contrast": 4.89
      },
      {
        "key": "a15",
        "name": "Пурпурный",
        "hex": "#dfa2c7",
        "foreground": "#000000",
        "contrast": 10.13
      },
      {
        "key": "a16",
        "name": "Розовый",
        "hex": "#c34f7e",
        "foreground": "#000000",
        "contrast": 4.74
      }
    ]
  }
}
